module.exports = __webpack_public_path__ + "img/Frame 39.0bb2e930.png";